import type { StoryObj } from '@storybook/html'
import { CobaltProgressIndicator, ProgressionBarTypes, ProgressionFractionsTypes } from './cobalt-progress-indicator'

type StoryBar = StoryObj<ProgressionBarTypes>
type StoryFractions = StoryObj<ProgressionFractionsTypes>

export default {
  title: 'Components/Feedback/cobalt-progress-indicator',
  tags: ['autodocs'],
  argTypes: {
    format: {
      control: 'none',
      options: ['bar', 'fractions'],
      description: 'Format of the progress indicator.',
      table: {
        type: { summary: 'string' },
        defaultValue: { summary: 'bar' }
      }
    },
    label: {
      type: { name: 'string', required: true },
      description: 'Label of the progress indicator.',
      table: {
        type: { summary: 'string' }
      }
    },
    hiddenLabel: {
      control: 'boolean',
      options: ['true', 'false'],
      description: 'Hide the label from the top of the progress indicator.',
      table: {
        type: { summary: 'string' }
      }
    },
    progression: {
      description: 'The progression value in the `bar` format. It is a percentage representation so it should be from 0 to 100.',
      control: 'none',
      table: {
        type: { summary: 'number' }
      }
    },
    total: {
      description: 'The number of step in the `fractions` format. The minimum of step should be 3 and the maximum should be 9.',
      control: 'none',
      table: {
        type: { summary: 'number' }
      }
    },
    current: {
      description: 'The current step number in the `fractions` format.',
      control: 'none',
      table: {
        type: { summary: 'number' }
      }
    },
    size: {
      description: 'The size of the progress indicator.',
      options: ['small', 'medium', 'large'],
      control: { type: 'select' },
      table: {
        type: { summary: 'string' },
        defaultValue: { summary: 'medium' }
      }
    }
  }
}

const Template = (args: CobaltProgressIndicator) => {
  return `
<cobalt-progress-indicator
  format="${args.format}"
  label="${args.label}"
  description="${args.description}"
  progression="${args.progression}"
  size="${args.size}"
  hidden-label="${args.hiddenLabel}"
></cobalt-progress-indicator>
  `
}

export const Default: StoryBar = Template.bind({})
Default.args = {
  format: 'bar',
  label: 'Progress Indicator',
  hiddenLabel: false,
  description: '',
  size: 'medium',
  progression: 50
}

const TemplateFractions = (args: CobaltProgressIndicator) => {
  return `
<cobalt-progress-indicator
  format="${args.format}"
  total="${args.total}"
  current="${args.current}"
  label="${args.label}"
  size="${args.size}"
></cobalt-progress-indicator>
  `
}

export const WithFractions: StoryFractions = TemplateFractions.bind({})
WithFractions.args = {
  format: 'fractions',
  label: 'Progress Indicator',
  hiddenLabel: false,
  description: '',
  size: 'medium',
  total: 9,
  current: 2
}
